module.exports = __webpack_public_path__ + "img/360-f8e7d0.png";